var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Youtube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7359",
    "data-name": "Rectangle 7359",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11018",
    "data-name": "Path 11018",
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Zm5.39,6.292A1.409,1.409,0,0,0,13.4,5.3,33.616,33.616,0,0,0,9,5.062,33.616,33.616,0,0,0,4.6,5.3a1.409,1.409,0,0,0-.995.995A14.645,14.645,0,0,0,3.375,9a14.643,14.643,0,0,0,.235,2.708A1.409,1.409,0,0,0,4.6,12.7a33.631,33.631,0,0,0,4.4.235,33.631,33.631,0,0,0,4.4-.235,1.409,1.409,0,0,0,.995-.995A14.643,14.643,0,0,0,14.625,9a14.645,14.645,0,0,0-.235-2.708Zm-6.515,4.4V7.313L10.8,9,7.875,10.688Z",
    transform: "translate(3 3)",
    fill: "#adb5b9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Youtube);
export default __webpack_public_path__ + "static/media/icon-24-youtube.2cded5f8fe7a757758d08a62a60c01dd.svg";
export { ForwardRef as ReactComponent };